module.exports = __webpack_public_path__ + "zilla-slab-latin-400.a4701e4e17daffd538f03fcfdb50c3fd.woff2";